// @flow

import { type PendingIncomingPayment } from './types';

export function getRedirectUrl(incomingPayment: PendingIncomingPayment): string {
  const redirectUrl = incomingPayment['redirect_url'];
  if (!redirectUrl)
    throw new Error('Redirect: Invalid state - There is no redirect_url property for this payment');

  return redirectUrl;
}
